import { CornerRadiusInputProps } from './CornerRadiusInput.types';

// This object should contain a mock value for each required prop of this component
export const requiredProps: CornerRadiusInputProps = {
  topLeft: {
    ariaLabel: 'top left corner input',
  },
  topRight: {
    ariaLabel: 'top right corner input',
  },
  bottomLeft: {
    ariaLabel: 'bottom left corner input',
  },
  bottomRight: {
    ariaLabel: 'bottom right corner input',
  },
  linkingButtonLabels: {
    pressed: 'Unlink',
    unpressed: 'Link',
  },
  linkedValuesChangedMessage: 'All corners have been updated',
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    },
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
